"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var GreenhouseLogoWhiteSquare = function GreenhouseLogoWhiteSquare(_ref) {
  var _ref$height = _ref.height,
    height = _ref$height === void 0 ? 24 : _ref$height,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 24 : _ref$width,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: height,
    width: width,
    className: className
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FEFEFE",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.677 13.602a2.415 2.415 0 0 0-2.412 2.412 2.415 2.415 0 0 0 2.412 2.412 2.415 2.415 0 0 0 2.412-2.412 2.415 2.415 0 0 0-2.412-2.412"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.677 19.823c-2.1 0-3.809-1.708-3.809-3.809 0-2.1 1.709-3.81 3.81-3.81 2.1 0 3.809 1.71 3.809 3.81s-1.71 3.81-3.81 3.81zm-.593-14.52A3.22 3.22 0 0 1 14.3 8.52a3.22 3.22 0 0 1-3.216 3.216 3.22 3.22 0 0 1-3.216-3.216 3.22 3.22 0 0 1 3.216-3.216zm2.471-1.517a.974.974 0 0 1 0 1.945.974.974 0 0 1 0-1.945zM0 23.496h23.495V0H0v23.495z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.084 10.323c.995 0 1.805-.809 1.805-1.804s-.81-1.804-1.805-1.804c-.995 0-1.805.81-1.805 1.804 0 .995.81 1.804 1.805 1.804"
  })));
};
var _default = exports["default"] = GreenhouseLogoWhiteSquare;